import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import { connect, useSelector } from "react-redux";
import blueGrey from "@material-ui/core/colors/blueGrey";
import context from "../../../../../../context/auth-context";
import { API_BASE_URL } from "../../../../../../constants";
import axios from 'axios';
import errorHandler from '../../../../../../hoc/ErrorHandler';
// import { useDispatch } from "react-redux";


const drawerWidth = 450;

const useStyles = makeStyles(() => ({
  list: {
    width: 300,
  },
  fullList: {
    width: "auto",
  },
  tableHead: {
    backgroundColor: blueGrey[50],
  },
  customTableContainer: {
    overflowX: "initial",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
}));

function LanguageDrawer(props) {
  const classes = useStyles();
  const isOpen = useSelector((state) => state.drawer.isOpen);
  const Languages = useSelector((state) => state.languages);
  const [languageSelected, setlanguageSelected] = useState([]);
  const [companyLanguageSelected, setCompanyLanguageSelected] = useState([]);
  const authContext = useContext(context);
  const [searchText, setSearchText] = useState("");
  // const dispatch = useDispatch();


  const handleDefaultChange = async (language, authContext) =>{
    fetch(
      `${API_BASE_URL}/companies/${authContext.companyId}/languages`,
      {
        method: "PATCH",
        headers: {
          Authorization: authContext.accessToken,
          "Company-Code": authContext.companyCode,
          "Company-Id": authContext.companyId.toString(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(language),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          fetch(
            `${API_BASE_URL}/companies/${authContext.companyId}/languages`,
            {
              method: "GET",
              headers: {
                "Company-Code": authContext.companyCode,
                "Company-Id": authContext.companyId.toString(),
              },
            }
          )
            .then((response) => response.json())
            .then((data) => {
              props.setCompanyLanguage(data);
              return data;
            })
            .catch((err) => console.log("ERROR"));
        }
      })
      .catch((error) => console.error(error));
  }

  const handleOnTextChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleChange = (e) => {
    e.persist();
    let newArray = [...languageSelected];
    let index;
    if (!Array.isArray(newArray) || !newArray.length);
    else index = newArray.indexOf(e.target.name);
    if (index > -1) {
      newArray.splice(index, 1);
    }
    e.target.checked
      ? !languageSelected.includes(e.target.name)
        ? setlanguageSelected((languageSelected) => [
          ...languageSelected,
          e.target.name,
        ])
        : setlanguageSelected(languageSelected)
      : setlanguageSelected(newArray);
  };
  const handleCompanyChange = (e) => {
    e.persist();
    let newArray = [...companyLanguageSelected];
    let index;
    if (!Array.isArray(newArray) || !newArray.length);
    else index = newArray.indexOf(e.target.name);
    if (index > -1) {
      newArray.splice(index, 1);
    }
    !e.target.checked
      ? !companyLanguageSelected.includes(e.target.name)
        ? setCompanyLanguageSelected((companyLanguageSelected) => [
          ...companyLanguageSelected,
          e.target.name,
        ])
        : setCompanyLanguageSelected(companyLanguageSelected)
      : setCompanyLanguageSelected(newArray);
  };
  useEffect(() => {
    let systemArray = [...Languages.systemLanguages.languages.language];
    let companyArray = [...Languages.companyLanguages.languages.language];
    let arrayTest = [];

    if (!languageSelected.length);
    else {
      for (let i = 0; i < languageSelected.length; i++) {
        let index = systemArray.findIndex(
          (x) => x.name === languageSelected[i]
        );

        if (index > -1) {
          arrayTest.push(systemArray[index]);
          companyArray.push(systemArray[index]);
        }
      }
      companyArray = companyArray.map((i) => {
        let temp = Object.assign({ is_default: "N" }, i);
        temp.id = Number(temp.id);
        temp.is_default = "N";
        return temp;
      });
      arrayTest = arrayTest.map((i) => {
        let temp = Object.assign({ is_default: "N" }, i);
        temp.id = Number(temp.id);
        temp.is_default = "N";
        return temp;
      });


      if (!isOpen.open) {
        for (let i = 0; i < arrayTest.length; i++) {
          fetch(
            `${API_BASE_URL}/companies/${authContext.companyId}/languages`,
            {
              method: "POST",
              headers: {
                Authorization: authContext.accessToken,
                "Company-Code": authContext.companyCode,
                "Company-Id": authContext.companyId.toString(),
                "Content-Type": "application/json",
              },
              body: JSON.stringify(arrayTest[i]),
            }
          )
            .then((response) => response.json())
            .then((response) => {
              if (response) {
                fetch(
                  `${API_BASE_URL}/companies/${authContext.companyId}/languages`,
                  {
                    method: "GET",
                    headers: {
                      "Company-Code": authContext.companyCode,
                      "Company-Id": authContext.companyId.toString(),
                    },
                  }
                )
                  .then((response) => response.json())
                  .then((data) => {
                    props.setCompanyLanguage(data);
                    return data;
                  })
                  .catch((err) => console.log("ERROR"));
              }
            })
            .catch((error) => console.error(error));
        }
      }
    }
    setSearchText("");
    return setlanguageSelected([]);
  }, [isOpen]);

  useEffect(() => {
    let companyArray = [...Languages.companyLanguages.languages.language];
    let arrayTest = [];

    if (!companyLanguageSelected.length);
    else {
      for (let i = 0; i < companyLanguageSelected.length; i++) {
        let index = companyArray.findIndex(
          (x) => x.name === companyLanguageSelected[i]
        );

        if (index > -1) {
          arrayTest.push(companyArray[index]);
          companyArray.splice(index, 1);
        }
      }

      arrayTest = arrayTest.map((i) => {
        let temp = Object.assign({}, i);
        temp.id = Number(temp.id);
        temp.is_default = "N";
        return temp;
      });



      if (!isOpen.open) {
        for (let i = 0; i < arrayTest.length; i++) {
          fetch(
            `${API_BASE_URL}/companies/${authContext.companyId}/languages`,
            {
              method: "DELETE",
              headers: {
                Authorization: authContext.accessToken,
                "Company-Code": authContext.companyCode,
                "Company-Id": authContext.companyId.toString(),
                "Content-Type": "application/json",
              },
              body: JSON.stringify(arrayTest[i]),
            }
          )
            .then((response) => response.json())
            .then((response) => {
              if (response) {
                fetch(
                  `${API_BASE_URL}/companies/${authContext.companyId}/languages`,
                  {
                    method: "GET",
                    headers: {
                      "Company-Code": authContext.companyCode,
                      "Company-Id": authContext.companyId.toString(),
                    },
                  }
                )
                  .then((response) => response.json())
                  .then((data) => {
                    props.setCompanyLanguage(data);
                    return data;
                  })
                  .catch((err) => console.log("ERROR"));
              }
            })
            .catch((error) => console.error(error));
        }
      }
    }
    setSearchText("");
    return setCompanyLanguageSelected([]);
  }, [isOpen]);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    props.closeLanguageDrawer(false);
  };

  const list = () => (
    <>
      <div className="form-group" style={{ padding: '20px 30px' }}>
        <h3>Languages</h3>
        <div className="input-search input-search-dark">
          <i className="input-search-icon md-search" aria-hidden="true"></i>
          <input
            type="text"
            className="form-control"
            name=""
            placeholder="Search for language..."
            value={searchText}
            onChange={handleOnTextChange}
          />
          <button
            type="button"
            className="input-search-close icon md-close"
            aria-label="Close"
            onClick={() => setSearchText("")}
          ></button>
        </div>
        {Languages.companyLanguages.languages !== null ? (
          searchText.length > 0 ? (
            Languages.companyLanguages.languages.language
              .filter((i) => {
                let x = searchText.toLocaleLowerCase();
                let y = i.name.slice(0, x.length).toLocaleLowerCase();
                return y === x ? y === x : false;
              })
              .map((company, index) => (
                <div className="checkbox-custom checkbox-primary" key={index}>
                  <input
                    type="checkbox"
                    value={company}
                    key={index}
                    id={company.id}
                    onClick={handleCompanyChange}
                    name={company.name}
                    defaultChecked
                  />
                  <label htmlFor="companyLang"  style={{fontWeight: 400}} className="active">{company.name}</label>
                  &nbsp;
                  {company.is_default === "Y" ? <></> : <button className="btn btn-link" style={{ padding: 'unset', float: 'right' }} onClick={() => handleDefaultChange(company, authContext)}>Make default</button>}

                </div>
              ))
          ) : (
            Languages.companyLanguages.languages.language.map(
              (company, index) => (
                <div className="checkbox-custom checkbox-primary" key={index}>
                  <input
                    type="checkbox"
                    value={company}
                    id={company.id}
                    onChange={handleCompanyChange}
                    key={index}
                    name={company.name}
                    defaultChecked
                  />
                  <label htmlFor="companyLang" style={{fontWeight: 400}} className="active">{company.name}</label>
                  &nbsp;
                  {company.is_default === "Y" ? <></> : <button className="btn btn-link" style={{ padding: 'unset', float: 'right' }} onClick={() => handleDefaultChange(company, authContext)}>Make default</button>}
                </div>
              )
            )
          )
        ) : (
          <span>No Company Languages Set</span>
        )}
        {Languages.systemLanguages.languages !== null ? (
          searchText.length > 0 ? (
            Languages.systemLanguages.languages.language
              .filter((i) => {
                let x = searchText.toLocaleLowerCase();
                let y = i.name.slice(0, x.length).toLocaleLowerCase();
                return y === x ? y === x : false;
              })
              .filter((systems) => {
                let x = [];
                Languages.companyLanguages.languages.language.map((y) =>
                  x.push(y.name)
                );
                return x.indexOf(systems.name) === -1;
              })
              .map((system, index) => (
                <div className="checkbox-custom checkbox-primary" key={index}>
                  <input
                    type="checkbox"
                    value={system}
                    id={system.id}
                    onChange={(e) => handleChange(e)}
                    name={system.name}
                  />
                  <label style={{fontWeight: 400}} htmlFor="systemLang">{system.name}</label>
                </div>
              ))
          ) : (
            Languages.systemLanguages.languages.language
              .filter((systems) => {
                let x = [];
                Languages.companyLanguages.languages.language.map((y) =>
                  x.push(y.name)
                );
                return x.indexOf(systems.name) === -1;
              })
              .map((system, index) => (
                <div className="checkbox-custom checkbox-primary" key={index}>
                  <input
                    type="checkbox"
                    value={system}
                    id={system.id}
                    onChange={(e) => handleChange(e)}
                    key={index}
                    name={system.name}
                  />
                  <label style={{fontWeight: 400}} htmlFor="systemLang">{system.name}</label>
                </div>
              ))
          )
        ) : (
          <span>Unable to fetch System Languages for you to choose from</span>

        )}
      </div>
    </>
  );

  return (
    <div>
      <React.Fragment>
        <Drawer
          anchor={"right"}
          className={classes.drawer}
          open={props.open}
          onClose={toggleDrawer(false)}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {list()}
        </Drawer>
      </React.Fragment>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeLanguageDrawer: (open) =>
      dispatch({ type: "CLOSE_LANGUAGE_DRAWER", payload: { open } }),
    addCompanyLanguage: (language) =>
      dispatch({ type: "SET_COMPANY_LANGUAGES", payload: { language } }),
    setCompanyLanguage: (language) =>
      dispatch({ type: "SET_COMPANY_LANGUAGES", payload: { language } }),
  };
};

export default connect(null, mapDispatchToProps)(errorHandler(LanguageDrawer, axios));
